module.exports = __webpack_public_path__ + "/img/e78a78cc3091eeba1292ecc1390a3298.png";